import AppConfig from '../appConfig'

class UrlFetcherFetch {
    static requestAccess(emailAddress) {
        const url = AppConfig.apiUrl+"/editor/url_fetcher/request";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'email_address': emailAddress
            })
        }).then((response => {
            return response.json()
        }));
    }

    static getUrl(idRequest, value, idCbiEntity, mode) {
        const url = AppConfig.apiUrl+"/editor/url_fetcher/"+idCbiEntity;

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'id_request': idRequest,
                'value': value,
                'mode': mode
            }),
        }).then((response => {
            return response.json()
        }));
    }
}

export default UrlFetcherFetch;